import { call, put, select } from 'redux-saga/effects';
import { ApiError, ApiResponse } from 'store/api/types';
import { ActivateViesRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import moment from 'moment';
import { activateVies } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { activateViesFailure, activateViesSuccess } from '../actions';

import { getAuthUser, getAuthUserLicence } from 'store/auth/selectors';
import { ViesInfo } from '../models';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { getCurrentSubscriptionRequest } from 'store/billing/actions';
import { LicenseStatus } from 'store/app/enums';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* activateViesSaga(action: ActivateViesRequestAction) {
  const currentUser = yield select(getAuthUser);
  try {
    let err: ApiError | null;
    const { connectionId, entityName } = action.payload;

    const response: ApiResponse = yield call(activateVies, connectionId);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.entity-activated-successfully', {
        entityName,
      }),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(activateViesSuccess(connectionId));
    const localRaw = localStorage.getItem(`vies-infos-${currentUser.userUuid}`);
    if (localRaw) {
      const localVies = JSON.parse(localRaw);
      const viesInfos: ViesInfo[] = localVies.viesInfos;
      const nIdx = viesInfos.findIndex(
        (lv) => lv.connectionId === connectionId
      );
      if (nIdx > -1) {
        viesInfos[nIdx].vatCheckerActive = true;
        localStorage.setItem(
          `vies-infos-${currentUser.userUuid}`,
          JSON.stringify({ timestamp: moment(), viesInfos })
        );
      }
    }
    const user = yield select(getAuthUser);
    const userLicence = yield select(getAuthUserLicence);
    if (user && userLicence?.status === LicenseStatus.ACTIVE) {
      yield put(getCurrentSubscriptionRequest(user.accountUuid));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(activateViesFailure());
  }
}
